import { PaymentElement } from "@stripe/react-stripe-js";
import { useState } from "react";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { colors } from "../../assets/colors";

export default function CheckoutForm({ includeAch }) {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsProcessing(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: `${window.location.origin}/completion`,
      },
    });

    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occured.");
    }

    setIsProcessing(false);
  };

  return (
    <form style={{cursor: "default"}} id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement 
        style={{ cursor: 'auto' }}
        options={{
          layout: "tabs",
          paymentMethodOrder: ["card", "us_bank_account"],
          
        }}
      />
      <button style={{ cursor: 'pointer', backgroundColor: colors.red }} disabled={isProcessing || !stripe || !elements} id="submit">
        <span style={{ cursor: 'pointer' }} id="button-text">
          {isProcessing ? "Processing ... " : "Contribute!"}
        </span>
      </button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
}
